<template>
  <div class="view-product-new bg-2 p-6 rounded-16">
    <h6 class="text-dark text-semibold fs-14 mb-4">
      Escolha o tipo de produto que você deseja vender
    </h6>
    <big-buttons
      class="pt-3"
      :options="[
        {
          id: 'online-course',
          name: 'Curso online',
          src: require(`@/assets/images/new-product/curso-online.svg`)
        },
        {
          id: 'signature',
          name: 'Assinatura',
          src: require(`@/assets/images/new-product/assinatura.svg`)
        },
        {
          id: 'event',
          name: 'Evento presencial',
          src: require(`@/assets/images/new-product/ticket.svg`)
        }
      ]"
      @input="open"
    />
  </div>
</template>

<script>
export default {
  methods: {
    open(type_product) {
      this.$router.push({ name: `product-new-${type_product}` });
    }
  }
};
</script>
